// extracted by mini-css-extract-plugin
export default {"content":"e5d479fd0117"};